import { createSlice } from '@reduxjs/toolkit'
import {getFactoryTypes} from "./thunks"
import { logOut } from '../authentication/authenticationSlice';

const initialState= { 
  types: [], 
  loading: "idle",
  error: null }

const factoryTypesSlice = createSlice({
  name: 'factoryTypes',
  initialState,
  reducers: {
    clearProvinceError: (state)=>{
      state.error = null
      state.loading = "idle"
    }
  },
  extraReducers: {
    [getFactoryTypes.pending]: (state) => {
        state.loading = "loading"; 
        state.error = null
      },
    [getFactoryTypes.fulfilled]: (state, action) => {
    state.loading = "succeeded";
    state.types = action.payload
      
    },
    [getFactoryTypes.rejected]: (state, action) => {
        state.loading = "failed"; 
        state.error = action.error.message
      },
    [logOut]: (state)=> initialState
  }
})

export const {clearProvinceError} = factoryTypesSlice.actions;
export default factoryTypesSlice.reducer
